import { SearchApiParams } from "../../../types/search";
import { atom } from "jotai";
import { atomWithQuery } from "jotai-tanstack-query";
import { authAtom } from "../../auth/atoms";
import { loadLocations } from "../../../apis/search";

export const tagVenueSearchParamsAtom = atom<SearchApiParams>({
  search: "",
  latitude: null,
  longitude: null,
  userlatitude: null,
  userlongitude: null,
  types: "",
  accessibilities: "",
  showVenueOptions: "All",
  addinfo: "",
  placesToReplaceString: "",
  searchThisAreaClicked: "no",
  zoom: "15",
  new_map: "1",
  tagging_mode: "on",
  progressive_update: "yes",
  userToken: "",
  saved_place_id: "",
  saved_place_user_id: "",
  saved_place_sortby: "",
  unixTimestamp: Math.floor(Date.now() / 1000), // Add unixTimestamp here
});

export const tagPinsAtom = atomWithQuery((get) => ({
  queryKey: [
    "tagPins",
    get(tagVenueSearchParamsAtom),
    get(authAtom)?.data?.accessToken,
  ],
  queryFn: async ({ queryKey: [, params, accessToken] }) => {
    const parameters = params as SearchApiParams;
    //const user = get(authAtom)?.data;
    if (parameters.latitude === null || parameters.longitude === null) {
      return {
        locations: [],
        accessibility_tags: [],
        newRegion: null,
        newLocation: null,
      };
    }
    return loadLocations(
      accessToken as unknown as string | null | undefined,
      parameters
    );
  },
}));
